import type { QueryClient } from '@tanstack/react-query'

import {
    REPORTS_DRAWER_QUERY_KEY,
    REPORTS_SUMMARY_TABLE_QUERY_KEY,
} from './reportsDownloadsKeys'

export async function invalidateReportsDownloadsQueries(
    queryClient: QueryClient
): Promise<void> {
    await Promise.all([
        queryClient.invalidateQueries({
            queryKey: [REPORTS_SUMMARY_TABLE_QUERY_KEY],
            type: 'all',
        }),
        queryClient.invalidateQueries({
            queryKey: [REPORTS_DRAWER_QUERY_KEY],
            type: 'all',
        }),
    ])
}
